import loadable from '@loadable/component';
import React from 'react'
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/EndPoint';
import Spinner from '../../components/Reusable/Spinner';

const MerchantComponent = loadable(
  () => import("../../components/Dashboard/MerchantOnboard")
);

const MerchantDashboard = () => {
  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`grid-data`],
    url: `${APIS.GRID_REPORT_DATA}`,
    params: {},
  });


  return (
    <>
      {isLoading ? <Spinner /> :
        <MerchantComponent
          gridData={gridData}
        />
      }

    </>
  )
}

export default MerchantDashboard
